import React from "react";
import Slider from "react-slick";
import avatar1 from "../../../images/avatar/avatar_11.webp";
import avatar2 from "../../../images/avatar/avatar_10.webp";
import avatar3 from "../../../images/avatar/avatar_9.webp";
import Bg from "../../../images/icons/icon_quote_2.svg";
import abImg1 from "../../../images/about/about_image_8.webp";
import abImg2 from "../../../images/icons/icon_wallet.svg";

import { Link } from "react-router-dom";

const testimonial = [
  {
    id: "01",
    Des: "One of my friends recommended Mr. Verma, CA, when I contacted him found him so friendly and responsive and taking personal attention and availing his services since last 03 years. He is very efficient, ensures accuracy and timely solutions, furthering trust and confidence.",
    Title: "Deveder Kumar",
    sub: "Board Member, UNIQA",
    avatar: avatar1,
  },
  {
    id: "02",
    Des: "I know Mr. Binod Verma, CA personally and availing his services since last 10 years. He is very efficient, ensures accuracy and timely solutions, fostering trust and confidence. Highly recommended for anyone seeking financial guidance.",
    Title: "Ravi Palekar",
    sub: "Board Member, UNIQA",
    avatar: avatar2,
  },
  {
    id: "03",
    Des: "CA Binod Verma is one of the most renowned and experienced CA of his field.Anyone can blindly trust on his work.",
    Title: "Sanjay Kumar",
    sub: "Board Member, UNIQA",
    avatar: avatar3,
  },
  {
    id: "04",
    Des: "We always need a consultant who describe u the intricacies of taxes in ur own language. And i found that in CA Bonod Verma. Highly recommend",
    Title: "Ramesh khulbey",
    sub: "Board Member, UNIQA",
    avatar: avatar1,
  },
  {
    id: "05",
    Des: "I personally know Mr Binod Verma, CA, he is very humble & efficient person. During the formation of my new partnership firm, he got done the job with in hours which was surrendered by a renowned CA Firm.",
    Title: "ML Gupta",
    sub: "Board Member, UNIQA",
    avatar: avatar2,
  },
  {
    id: "06",
    Des: "Very good work and nature aisa ki aaj tk mujhe koi aisa insaan nhi mila binod sir you are bery good human being aapke sath work k bht achcha lga mujhe age bhi sath kaam karenge",
    Title: "Mohammad Kashif",
    sub: "Board Member, UNIQA",
    avatar: avatar3,
  },
];

const BusinessTestimonial = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const settings = {
    dots: false,
    arrows: false,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const slider = React.useRef(null);

  return (
    <section className="review_and_about_section section_space bg-light">
      <div className="container">
        <div
          className="review_bg_box bg-success"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="heading_block text-center text-white">
            <h2 className="heading_text mb-0">Client Reviews on Google</h2>
          </div>
          <div className="review_4col_carousel swiper">
            <Slider ref={slider} {...settings}>
              {testimonial.map((testimonial, tsm) => (
                <div className="review_block_3" key={tsm}>
                  <ul className="rating_block unordered_list">
                    <li>
                      <i className="fa-solid fa-star fa-fw"></i>
                    </li>
                    <li>
                      <i className="fa-solid fa-star fa-fw"></i>
                    </li>
                    <li>
                      <i className="fa-solid fa-star fa-fw"></i>
                    </li>
                    <li>
                      <i className="fa-solid fa-star fa-fw"></i>
                    </li>
                    <li>
                      <i className="fa-solid fa-star fa-fw"></i>
                    </li>
                  </ul>
                  <p className="review_commtent">"{testimonial.Des}"</p>
                  <div className="review_admin">
                    <div className="review_admin_image">
                      <img src={testimonial.avatar} alt="Maverick Phoenix" />
                    </div>
                    <div className="review_admin_info">
                      <h4 className="review_admin_name">{testimonial.Title}</h4>
                      {/* <span className="review_admin_designation">
                        {testimonial.sub}
                      </span> */}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
      <div className="section_space pb-0">
        <div className="container">
          <div className="row align-items-center justify-content-lg-around">
            <div className="col-lg-6">
              <div className="heading_block">
                <h2 className="heading_text">
                  Why Choose Us: Empowering Your Financial Success
                </h2>
                <p className="heading_description text-dark pe-lg-5">
                  Unlock your business's true potential with expert financial
                  guidance. From tailored accounting solutions to strategic tax
                  planning, we ensure compliance, efficiency, and growth. Choose
                  Achieve More with Trusted Expertise
                </p>
                <p className="heading_description mb-0 text-dark pe-lg-5">
                  Maximize profitability, streamline financial operations, and
                  stay ahead with our dedicated chartered accountancy services.
                  Let’s Build Success Together – Get Started Today!
                </p>
              </div>
              <Link onClick={ClickHandler} className="creative_btn" to="/about">
                <span className="btn_label bg-primary">Get Started Today</span>
                <span className="btn_icon">
                  <i className="bg-primary fa-solid fa-arrow-up-right"></i>
                  <i className="bg-primary fa-solid fa-arrow-up-right"></i>
                </span>
              </Link>
            </div>
            <div className="col-lg-4">
              <div className="about_image_3">
                <img
                  className="image_wrap"
                  src={abImg1}
                  alt="Business Consulting"
                />
                <div className="funfact_block capsule_layout">
                  <div className="funfact_icon">
                    <img src={abImg2} alt="CA Binod Verma - Laxmi Nagar" />
                  </div>
                  <div className="funfact_content">
                    <h3 className="funfact_title mb-0">Audits Completed</h3>
                    <div className="counter_value">
                      <span></span>
                      <span className="odometer" data-count="50000">
                        50000+
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessTestimonial;
